import {makeStyles} from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
          margin: '.5em',
        },
      },
      paper: {
        padding: '2em',
      },
      form: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
      },
      selectInput : {
          marginBottom : '1em'
      },
      feuilleMatch: {
        justifyContent :"space-evenly",
        alignItems : "center",
        [theme.breakpoints.up('xs')]: {
          flexDirection: 'column!important',
        },
        [theme.breakpoints.up('sm')]: {
          flexDirection: 'row!important',
        }
      },
      selectInField: {
        width : '120px',
        background : 'white',
        visible : 'hidden'
      },
      typoInCustoSelect:{
        '&:hover' : {
          background : 'lightgrey',
          cursor : 'pointer'
        }
      }
}));